import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
export function useDebouncedValue(value, delayMs) {
  const $ = _c(4);
  const [debouncedValue, setDebouncedValue] = useState(value);
  let t0;
  let t1;
  if ($[0] !== delayMs || $[1] !== value) {
    t0 = () => {
      const timer = window.setTimeout(() => setDebouncedValue(value), delayMs);
      return () => window.clearTimeout(timer);
    };
    t1 = [value, delayMs];
    $[0] = delayMs;
    $[1] = value;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return debouncedValue;
}